import React, { useEffect, useState } from "react";
import loyalProgramHeaderImage from "../../assets/loyalprogramheader.png";
import { RxCross1 } from "react-icons/rx";
import api from "../../utils/api.js";
import { useSelector } from "react-redux";
import { useSocket } from "../../context/SocketContext.js";
import { FaSpinner } from "react-icons/fa";

const LoyaltyProgram = () => {
  const [points, setPoints] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true); // Only for first load
  const { user } = useSelector((state) => state.user);
  const socket = useSocket();

  useEffect(() => {
    if (!socket) return;

    socket.on("order-cancelled", ({ orderId }) => {
      console.log("-----", orderId);
    });

  }, [socket]);

  useEffect(() => {
    const fetchPoints = async () => {
      try {
        const response = await api.get(`/current-points/user/${user._id}`);
        setPoints(response.data.data.currentPoint);
      } catch (error) {
        console.error("Error fetching points:", error);
      } finally {
        setInitialLoading(false); // Set loading to false only after the first API call
      }
    };

    fetchPoints(); // Initial fetch
    const interval = setInterval(fetchPoints, 2000); // Periodic updates

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <>
      <div className="relative bg-[#AF313D]  p-6 flex items-center justify-center md:h-[115px] lg:h-[264px] h-[81px]">
        <div className="flex w-full items-center justify-center relative">
          <h2 className="text-[22px] body sm:text-[27px] md:text-[30px] lg:text-[40px] font-bold text-white">
            Loyalty Program
          </h2>
          <img
          onClick={() => setShowPopup(true)}
            src={loyalProgramHeaderImage}
            alt="Gift box"
            className="absolute md:right-4 lg:right-12 sm:right-2 -right-2 top-0 md:-top-8 w-[105px] h-[61.72px] md:w-[242px] md:h-[125px] lg:w-[346px] lg:h-[170px] z-10"
          />
        </div>
      </div>

      <div className="relative">
        <div className="absolute left-1/2 transform -translate-x-1/2 bg-white px-6 rounded-xl shadow-lg w-[90%] sm:w-[80%] md:w-[80%] lg:w-[80%] h-[170px] sm:h-[123px] md:h-[150px] lg:h-[200px] flex flex-col items-center top-[calc(50%-10px)] sm:top-[calc(50%-15px)] md:top-[calc(60%-20px)] lg:top-[calc(70%-55px)] z-0">
          <p className="font-semibold mt-6 body md:text-[15.8px]">Your Cashback Points</p>
          <p className="text-2xl font-bold text-center flex items-center justify-center mt-2">
            <span className="text-white body bg-black rounded-full w-[30px] h-[30px] flex items-center justify-center mr-4">
              £
            </span>
            {initialLoading ? (
              <div className="flex justify-center items-center">
                <FaSpinner className="animate-spin text-4xl text-[#AF313D] " />
              </div>
            ) : (
              points
            )}
          </p>

          <button
            className="absolute right-0 bottom-0 mb-6 mr-6 bg-[#AF313D] text-white rounded-full
             h-[18.5px] w-[92px] flex items-center justify-center
             sm:h-[48px] sm:w-[154px] sm:text-[20px] sm:font-semibold
             md:h-[48px] md:w-[224px] md:text-[20px] md:font-semibold
             lg:h-[48px] lg:w-[324px] lg:text-[20px] lg:font-semibold xl:w[424px]"
            onClick={() => setShowPopup(true)}
          >
            <span className="font-semibold body text-[7.64px] leading-3 text-center sm:text-[14px] md:text-[18px] lg:text-[20px]">
              How to earn cashback
            </span>
          </button>
        </div>
      </div>

      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-[90%] sm:w-[70%] md:w-[50%] lg:w-[43%] relative">
            <button
              className="absolute top-3 right-3 text-white flex items-center justify-center w-[20px] h-[20px] md:w-[30px] md:h-[30px] rounded-full bg-black hover:text-black hover:bg-white"
              onClick={() => setShowPopup(false)}
            >
              <RxCross1 className="md:text-[20px] text-[14px]" />
            </button>

            <h2 className="text-lg md:text-2xl font-bold mb-4 text-center">
            Place an order through our website and earn cashback!
          </h2>

            <ul className="list-disc list-inside font-medium px-4 mt-5 text-[#585857] space-y-3 text-sm md:text-[14px] lg:text-[16px]">
              <li>Get 100% cashback on orders below £25.
              </li>
              <li>Enjoy 50% cashback on orders between £25 and £50.
              </li>
              <li>Receive 30% cashback on orders between £50 and £70.</li>
              {/* <li>Participate in promotions to collect more points.</li> */}
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default LoyaltyProgram;
